import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import InActivityLogoutModal from "../components/InActivityLogoutModal/InActivityLogoutModal";
import { performLogout } from "./index";

const InactivityLogoutTimer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [countdown, setCountdown] = useState(60);
  const [showAlert, setShowAlert] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);

  const pathNames =
    location.pathname !== "/" &&
    location.pathname !== "/whyogiso" &&
    location.pathname !== "/pricing" &&
    location.pathname !== "/login" &&
    location.pathname !== "/signup" &&
    location.pathname !== "/term-conditions" &&
    location.pathname !== "/contact-us" &&
    location.pathname !== "/cookies-policy";

  useEffect(() => {
    const checkForInactivity = () => {
      const expireTimeString = localStorage.getItem("expireTime");
      const expireTime = expireTimeString ? parseInt(expireTimeString) : 0;
      if (pathNames && expireTime < Date.now()) {
        if (!showAlert) {
          setShowAlert(true);
        }
      }
    };

    const updateExpiryTime = () => {
      // <----- 30 mins === 1800000 ms, 29 mins = 1740000, 1 min === 60000 ms -----> \\

      const expireTime = Date.now() + 1740000; // -----> Pass above time here to show popup after that amount of time. -----> \\
      localStorage.setItem("expireTime", expireTime.toString());
    };

    const handleActivity = () => {
      updateExpiryTime();
    };

    // Check immediately when the page becomes visible again (handles screen-off / sleep scenarios
    // where setInterval is throttled by the browser)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkForInactivity();
      }
    };

    const events = ["click", "keypress", "scroll", "mousemove"];
    events.forEach((event) => window.addEventListener(event, handleActivity));
    document.addEventListener("visibilitychange", handleVisibilityChange);

    const intervalId = setInterval(checkForInactivity, 5000);
    updateExpiryTime();

    return () => {
      clearInterval(intervalId);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [location, navigate, showAlert, pathNames]);

  useEffect(() => {
    if (showAlert) {
      const logoutAt = Date.now() + 60000;

      const tick = () => {
        const remaining = Math.ceil((logoutAt - Date.now()) / 1000);
        if (remaining <= 0) {
          setShowAlert(false);
          performLogout("/");
          setCountdown(0);
        } else {
          setCountdown(remaining);
        }
      };

      // Run on visibility change so the countdown reflects real elapsed time after sleep/screen-off
      const handleCountdownVisibility = () => {
        if (document.visibilityState === "visible") {
          tick();
        }
      };

      document.addEventListener("visibilitychange", handleCountdownVisibility);
      const timer = setInterval(tick, 500);

      return () => {
        clearInterval(timer);
        document.removeEventListener(
          "visibilitychange",
          handleCountdownVisibility
        );
      };
    }
  }, [showAlert, navigate]);

  useEffect(() => {
    if (location.pathname === "/") {
      setShowAlert(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!showAlert && countdown >= 0) {
      open();
      setCountdown(60);
    }
  }, [showAlert, countdown]);

  return (
    pathNames &&
    showAlert && (
      <InActivityLogoutModal
        opened={opened}
        close={close}
        setShowAlert={setShowAlert}
        countdown={countdown}
        setCountdown={setCountdown}
        navigate={navigate}
      />
    )
  );
};

export default InactivityLogoutTimer;